import imageUrlBuilder from '@sanity/image-url';

export default imageUrlBuilder({
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || '',
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || '',
});
